import { DataIdSchema } from "@/schemas";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/calendar/events/$id")({
	params: {
		parse: (params) => ({
			id: DataIdSchema.parse(Number(params.id)),
		}),
		stringify: ({ id }) => ({ id: id?.toString() }),
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
